
import { FeaturesCards, VisionCards } from "@app/components";
import { imageSource, Strings } from "@app/constants";
import { Footer } from "@app/modules/footer";
import { PremiumServicesSection } from "./our-preminum-service";
import { Categories } from "./category";
import { RideSlider } from "./rideSlide";
import { visionData } from "../visionData";
import { featureData } from "../featureData";
import { categoriesData } from "../categoriesData";
import { DialogBox } from "./dialogBox";
import { useDialog } from "@app/hooks";
import { Philosophy } from "./Philosophy";
import { Stack } from "@mui/material";

const LandingPage = () => {
  const DialogBoxPopUp = useDialog();
  return (
    <>
      <Stack
        sx={{
          width: "100%",
          minHeight: "100vh",
          overflowX: "hidden",
          "&::-webkit-scrollbar": {
            display: "none",
          },
        }}
      >
        <RideSlider DialogBoxPopUp={DialogBoxPopUp} />
        <Categories
          categories={categoriesData}
          DialogBoxPopUp={DialogBoxPopUp}
        />
        <FeaturesCards
          heading={Strings.home.whyUseUs}
          subHeading={Strings.home.weOfferThe}
          features={featureData}
          rightImage={imageSource.fortuner_and_bike}
        />
        <PremiumServicesSection />
        <VisionCards heading={Strings.heading.ourVision} items={visionData} />
        <Stack width={{xs:"90%", md:"80%"}} alignSelf={"center"} mb={5}>
        <Philosophy/>
        </Stack>
        <Footer />
        {DialogBoxPopUp.visible && (
          <DialogBox
            open={DialogBoxPopUp.show}
            onClose={DialogBoxPopUp.hide}
            onClick={DialogBoxPopUp.hide}
          />
        )}
      </Stack>
    </>
  );
};

export { LandingPage };
